export const HiringTypeMap = {
  '/m/beidou': '2_3,1_3',
  '/m/qihang': '2_4,1_4',
  '/m/social': '3_5',
  '/m/campus': '1,2',
  '/m/share/position': '',
  '/m/position': '',
};
